import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { string } from 'prop-types';

const EmptyCard = ({ title, subtitle }) => (
  <Stack
    sx={{
      alignItems: 'center',
      backgroundColor: 'graphic.lighter',
      // eslint-disable-next-line sort-keys-fix/sort-keys-fix
      height: { xs: 255, lg: 155 },
      justifyContent: 'center',
      // eslint-disable-next-line sort-keys-fix/sort-keys-fix
      mt: { xs: 2, lg: 8 },
      p: 3,
      width: '100%',
    }}
  >
    <SearchRoundedIcon sx={{ color: 'graphic.icons', height: 38, mb: 1, width: 38 }} />
    <Typography
      sx={{
        color: 'text.secondary',
        fontWeight: 400,
        textAlign: 'center',
      }}
      variant="h6"
    >
      {title}
    </Typography>
    <Typography sx={{ color: 'text.secondary', textAlign: 'center' }} variant="body1">
      {subtitle}
    </Typography>
  </Stack>
);

EmptyCard.propTypes = {
  subtitle: string.isRequired,
  title: string.isRequired,
};

export default EmptyCard;
